export default function ClientDocumentsTab({ documents }) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-slate-900">Documenten</h3>

      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500">
              <th className="px-2 py-2 font-medium">Bestandsnaam</th>
              <th className="px-2 py-2 font-medium">Documenttype</th>
              <th className="px-2 py-2 font-medium">Datum upload</th>
              <th className="px-2 py-2 font-medium">Gekoppeld aan</th>
              <th className="px-2 py-2 font-medium">Actie</th>
            </tr>
          </thead>
          <tbody>
            {documents.map((document) => (
              <tr key={document.id} className="border-b border-slate-100 last:border-b-0">
                <td className="px-2 py-3 font-medium text-slate-800">{document.bestandsnaam}</td>
                <td className="px-2 py-3 text-slate-700">{document.documenttype}</td>
                <td className="px-2 py-3 text-slate-700">{document.datumUpload}</td>
                <td className="px-2 py-3 text-slate-700">{document.gekoppeldAan}</td>
                <td className="px-2 py-3">
                  <div className="flex gap-2">
                    <button type="button" className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50">
                      Openen
                    </button>
                    <button type="button" className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50">
                      Downloaden
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
